import { FacilityUsageStatus } from "src/api/contract/facility-usage-slot-types";
import { facilityUsageStatusChipClass, facilityUsageStatusLabel } from "../commonSpaceSettlement-types";

/**
 * 정산 상태 칩 (예정/확정/취소)
 */
const FacilityUsageStatusChip = ({ status }: { status?: FacilityUsageStatus }) => {
  if (!status) return <>-</>;
  return <div className={`chip ${facilityUsageStatusChipClass[status]}`}>{facilityUsageStatusLabel[status]}</div>;
};

export default FacilityUsageStatusChip;
